import { Component, ViewChild } from '@angular/core';
import { Chart } from 'chart.js';
import { IonicPage, NavController, NavParams, App } from 'ionic-angular';
import { ComplaintsProvider, Response } from '../../providers/complaints/complaints';
import { ComplaintsDetailsPage } from '../complaints-details/complaints-details';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-all-complaints',
  templateUrl: 'all-complaints.html',
})
export class AllComplaintsPage {
  @ViewChild('pieChart') pieChart;
  params: any = {
    items: []
  };
  page_no: number = 1;
  complaint: any;
  message: string;
  showData = false;
  enableRefresh = true;
  doughnutChart: any;
  public pieChartE1: any;
  public chartLabels: any = [];
  public chartValues: any = [];
  public chartColours: any = [];
  public chartHoverColours: any = [];
  public chartLoading: any;
  selRegistrationLogin  : any;

  constructor(
    private app: App, 
    public navCtrl: NavController, 
    private translate: TranslateService,
    public navParams: NavParams, 
    private complaintsProvider: ComplaintsProvider) {
      this.selRegistrationLogin = localStorage.getItem('signup_login')

      if(this.selRegistrationLogin){
        this.showData = true;
      }
  else{

    this.complaintsProvider.getComplaints("", this.page_no).then((res) => {
      this.showDetails(res);
      this.showData = true;
    });

    this.complaintsProvider.getComplaintStatusCount().then((val) =>{
      this.showData = true;
  		if(val.status == "success"){
        this.pieChartData(val.data);
  		}
    });
  }
  }
  pieChartData(pieChartData){
    let index : any;
    for(index in pieChartData){
      this.chartValues[index]=0;
      var k=pieChartData[index];
      this.chartValues[index]=k.count;
      this.chartLabels[index]=k.status;
    }
    this.ionViewDidLoad1()
  }

  onItemClick(complaint: any){
    this.complaint = complaint;
    this.app.getRootNav().push(ComplaintsDetailsPage,  {
      complaint: this.complaint,
      parentPage: this
    }
    );
  }

  showDetails(res: Response){
    if(res.data.length == 0){
      this.message = this.translate.instant("NO_MORE_RECORDS_FOUND");
      this.enableRefresh = false;
    }
    else{
      res.data.forEach(element => {
        // element.com_no = String(element.com_no).slice(4,);
        element.icon_img = "assets/images/complaints/"+element.complaint_type+".png";
        this.params.items.push(element);
      });
      this.page_no++;
    }
  }

  doInfinite(infiniteScroll) {
    console.log("page test"+this.page_no);
    
    this.complaintsProvider.getComplaints("",this.page_no).then(res => {
      this.showDetails(res);
      infiniteScroll.complete();
    });
  }

  doRefresh(refresher) {
    if(this.selRegistrationLogin){
      setTimeout(() => {
        this.showData = true;
        refresher.complete() 
        },2000)
    }
    else{
    this.page_no = 1;
    this.complaintsProvider.getComplaints("", this.page_no).then((res) => {
      this.params.items = [];
      this.showDetails(res);
      this.enableRefresh = true;
      this.message = "";
      refresher.complete();
    });
    this.complaintsProvider.getComplaintStatusCount().then((val) =>{
      this.showData = true;
  		if(val.status == "success"){
        this.pieChartData(val.data);
  		}
    });
  }
  }

  refresh(){
    this.page_no = 1;
    this.complaintsProvider.getComplaints("", this.page_no).then((res) => {
      this.params.items = [];
      this.showDetails(res);
    });
    
  }

  ionViewDidLoad1() {
    this.pieChartE1 			= 	new Chart(this.pieChart.nativeElement,
      {
         type: 'pie',
         data: {
            labels: this.chartLabels,
            datasets: [{
               data : this.chartValues,
               duration : 2000,
               easing : 'easeInQuart',
               backgroundColor : [
                'rgba(255, 99, 132, 0.7)',
                'rgba(54, 162, 235, 0.7)',
                'rgba(255, 206, 86, 0.7)',
                'rgba(75, 192, 192, 0.7)',
                'rgba(153, 102, 255, 0.7)',
                'rgba(255, 159, 64, 0.7)'
            ],
               hoverBackgroundColor  : [
                "#FF6384",
                "#36A2EB",
                "#FFCE56",
                "#FF6384",
                "#36A2EB",
                "#FFCE56"
            ]
            }]
         },
         options : {
            maintainAspectRatio: false,
            animation: {
               duration : 3000
            }
         }
      });
      this.chartLoading = this.pieChartE1.generateLegend();
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad AllComplaintsPage');
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/all-complaints/all-complaints.ts